<template>
  <div class="flex flex-row justify-between flex-wrap gap-x-4 gap-y-2">
    <div class="flex flex-row items-center">
      <div class="pr-2" aria-hidden="true">
        <ClockIcon class="h-5 text-br-green" />
      </div>
      <div>
        <div class="fluid-xs leading-tight tracking-wider font-medium text-gray-500">
          {{ $t('exercises.duration') }}
        </div>
        <div class="fluid-xs leading-tightest font-medium">{{ duration }}</div>
      </div>
    </div>

    <div class="flex flex-row items-center">
      <div class="pr-2" aria-hidden="true">
        <ExerciseIcon class="h-5 text-br-green" />
      </div>
      <div>
        <div class="fluid-xs leading-tight tracking-wider font-medium text-gray-500">
          {{ $t('exercises.exercises') }}
        </div>
        <div class="fluid-xs leading-tightest font-medium">{{ exerciseCount }}</div>
      </div>
    </div>

    <div class="flex flex-row items-center">
      <div class="pr-2" aria-hidden="true">
        <DifficultyIcon class="h-5 text-br-green" />
      </div>
      <div>
        <div class="fluid-xs leading-tight tracking-wider font-medium text-gray-500">
          {{ $t('exercises.difficulty') }}
        </div>
        <div class="routine-value">{{ difficulty }}</div>
      </div>
    </div>

    <slot />
  </div>
</template>

<script setup>
import ExerciseIcon from '@/components/icons/ExerciseIcon.vue';
import DifficultyIcon from '@/components/icons/DifficultyIcon.vue';
import ClockIcon from '~/components/icons/ClockIcon.vue';

defineProps({
  duration: {
    type: String,
    default: '',
  },
  exerciseCount: {
    type: [Number, String],
    default: 0,
  },
  difficulty: {
    type: String,
    default: '',
  },
});
</script>

<style scoped>
@reference "~/assets/css/main.css";
.routine-icon {
  @apply pr-3;
}
.routine-description {
  @apply fluid-xs leading-tight tracking-wider font-medium text-gray-500;
}
.routine-value {
  @apply fluid-xs leading-tightest font-medium;
}
</style>
